import moment from 'moment'
import { defineStore } from 'pinia'
import { reactive, readonly } from 'vue'
import { userRole } from '../internalUser/internalUser'

enum gender {
  MALE = 'male',
  FEMALE = 'female'
}

export interface iUserProfile {
  id: number
  fullname: string
  email: string
  phone: string
  gender: gender
  alamat: string
  npwp: string | null
  role: userRole
  last_login: moment.Moment | null
  created_at: moment.Moment | null
  reset_token: string | null
  reset_token_expired_at: moment.Moment | null
  instagram: string | null
  linkedin: string | null
  twitter: string | null
  link_others: string | null
  short_bio: string | null
  thumbnail: string | null
}

export const userProfileStore = defineStore('userProfile', () => {
  const profile = reactive<iUserProfile>({
    id: 0,
    fullname: '',
    email: '',
    phone: '',
    gender: gender.MALE,
    alamat: '',
    npwp: null,
    role: userRole.ADMIN,
    last_login: null,
    created_at: null,
    reset_token: null,
    reset_token_expired_at: null,
    instagram: null,
    linkedin: null,
    twitter: null,
    link_others: null,
    short_bio: null,
    thumbnail: null
  } as iUserProfile)

  const getUserProfile = readonly(profile)

  function setUserProfile(userProfileObject: iUserProfile) {
    if(userProfileObject?.id == null) return
    profile.id = userProfileObject.id
    profile.fullname = userProfileObject.fullname
    profile.email = userProfileObject.email
    profile.phone = userProfileObject.phone
    profile.gender = userProfileObject.gender
    profile.alamat = userProfileObject.alamat
    profile.npwp = userProfileObject.npwp
    profile.role = userProfileObject.role
    profile.last_login = userProfileObject.last_login
    profile.created_at = userProfileObject.created_at
    profile.reset_token = userProfileObject.reset_token
    profile.reset_token_expired_at = userProfileObject.reset_token_expired_at
    profile.instagram = userProfileObject.instagram
    profile.linkedin = userProfileObject.linkedin
    profile.twitter = userProfileObject.twitter
    profile.link_others = userProfileObject.link_others
    profile.short_bio = userProfileObject.short_bio
    profile.thumbnail = userProfileObject.thumbnail
  }

  function setDefault() {
    profile.id = 0
    profile.fullname = ''
    profile.email = ''
    profile.phone = ''
    profile.gender = gender.MALE
    profile.alamat = ''
    profile.npwp = null
    profile.role = userRole.ADMIN
    profile.last_login = null
    profile.created_at = null
    profile.reset_token = null
    profile.reset_token_expired_at = null
    profile.instagram = null
    profile.linkedin = null
    profile.twitter = null
    profile.link_others = null
    profile.short_bio = null
    profile.thumbnail = null
  }

  return { getUserProfile, setUserProfile, setDefault }
})
